// extracted by mini-css-extract-plugin
export default {"annotatedImageHeading":"AnnotatedImageWrapper__annotatedImageHeading___DqAAB fonts__whitney-bold___Hcpj8","exemplarResponse":"AnnotatedImageWrapper__exemplarResponse___avZWz"};